let searchScrollPosition = 0;

function openSearchModal() {
  const searchModal = document.getElementById('search-modal');
  if (!searchModal) return;
  searchScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  document.body.style.top = `-${searchScrollPosition}px`;
  document.body.style.position = 'fixed';
  document.body.style.width = '100%';
  document.body.style.overflow = 'hidden';
  searchModal.classList.add('active');
  searchModal.setAttribute('aria-hidden', 'false');
  document.body.classList.add('search-open', 'modal-open');
}

function closeSearchModal() {
  const searchModal = document.getElementById('search-modal');
  if (!searchModal) return;
  searchModal.classList.remove('active');
  searchModal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('search-open', 'modal-open');
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  document.body.style.overflow = '';
  window.scrollTo(0, searchScrollPosition);
}

document.addEventListener('DOMContentLoaded', () => {
  const searchModal = document.getElementById('search-modal');
  const input = document.getElementById('search-input');
  const resultsContainer = document.getElementById('search-results');
  const form = document.querySelector('.search-form');
  const toggleButtons = document.querySelectorAll('[data-search-toggle]');
  let debounceTimer;

  toggleButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const action = btn.dataset.searchToggle;
      if (action === 'open') openSearchModal();
      if (action === 'close') closeSearchModal();
    });
  });

  if (searchModal) {
    searchModal.addEventListener('click', (e) => {
      const content = searchModal.querySelector('.search-modal__content');
      if (!content.contains(e.target)) closeSearchModal();
    });
  }

  if (form) {
    form.addEventListener('submit', (e) => e.preventDefault());
  }

  if (input) {
    input.addEventListener('input', (e) => {
      const query = e.target.value.trim();
      clearTimeout(debounceTimer);
      if (query.length < 2) { resultsContainer.innerHTML = ''; return; }
      debounceTimer = setTimeout(() => {
        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`)
          .then(res => res.json())
          .then(data => {
            const products = data.resources?.results?.products || data.resources?.products?.results || [];
            renderSearchResults(products);
          })
          .catch(() => {
            resultsContainer.innerHTML = `<p class="no-results">No products found.</p>`;
          });
      }, 250);
    });
  }

  function renderSearchResults(products) {
    if (!products.length) {
      resultsContainer.innerHTML = `<p class="no-results">No products found.</p>`;
      return;
    }
    resultsContainer.innerHTML = products.map((product) => {
      const imageUrl = product.featured_image ? product.featured_image.url : '';
      const priceWithTaxCents = Math.round((product.price || 0) * 110);
      const formattedPrice = Shopify.formatMoney(priceWithTaxCents, Shopify.money_format);
      return `
        <a href="${product.url}" class="search-result">
          ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" width="80" height="80" />` : ''}
          <div class="search-result__info">
            <p class="search-result__title">${product.title}</p>
            <p class="product__price">${formattedPrice} <span class="tax-note">(tax in)</span></p>
          </div>
        </a>`;
    }).join('');
  }

  document.body.classList.remove('js-not-loaded');
});